import Nullstack from 'nullstack';
export default function IconMap2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-map-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "18",
    y1: "6",
    x2: "18",
    y2: "6.01"
  }), "   ", Nullstack.element("path", {
    d: "M18 13l-3.5 -5a4 4 0 1 1 7 0l-3.5 5"
  }), "   ", Nullstack.element("polyline", {
    points: "10.5 4.75 9 4 3 7 3 20 9 17 15 20 21 17 21 15"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "4",
    x2: "9",
    y2: "17"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "15",
    x2: "15",
    y2: "20"
  }), " ");
}